__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "@shipbob/returns_ui";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@fortawesome/fontawesome-svg-core", "6.5.1", () => (__webpack_require__.e(7107).then(() => (() => (__webpack_require__(37107))))));
			register("@fortawesome/free-solid-svg-icons", "6.5.1", () => (__webpack_require__.e(6188).then(() => (() => (__webpack_require__(66188))))));
			register("@fortawesome/vue-fontawesome", "3.0.5", () => (Promise.all([__webpack_require__.e(6962), __webpack_require__.e(2856), __webpack_require__.e(1273)]).then(() => (() => (__webpack_require__(61273))))));
			register("@primeuix/styled", "0.3.2", () => (__webpack_require__.e(3505).then(() => (() => (__webpack_require__(73505))))));
			register("@primeuix/utils", "0.3.2", () => (Promise.all([__webpack_require__.e(9587), __webpack_require__.e(1079)]).then(() => (() => (__webpack_require__(61079))))));
			register("@shipbob/auth", "1.7.0", () => (__webpack_require__.e(3667).then(() => (() => (__webpack_require__(13667))))));
			register("@shipbob/shipbob_api_client", "1.2.0", () => (__webpack_require__.e(2241).then(() => (() => (__webpack_require__(92241))))));
			register("@shipbob/telemetry", "1.6.0", () => (__webpack_require__.e(1036).then(() => (() => (__webpack_require__(21036))))));
			register("axios", "1.20.0", () => (__webpack_require__.e(7069).then(() => (() => (__webpack_require__(87069))))));
			register("date-fns", "4.1.0", () => (__webpack_require__.e(4353).then(() => (() => (__webpack_require__(44353))))));
			register("mitt", "3.0.1", () => (__webpack_require__.e(7380).then(() => (() => (__webpack_require__(27380))))));
			register("moment-timezone", "0.5.43", () => (Promise.all([__webpack_require__.e(4743), __webpack_require__.e(5955)]).then(() => (() => (__webpack_require__(84743))))));
			register("moment", "2.31.0", () => (Promise.all([__webpack_require__.e(72), __webpack_require__.e(5358)]).then(() => (() => (__webpack_require__(95093))))));
			register("vue-axios", "3.5.2", () => (__webpack_require__.e(1021).then(() => (() => (__webpack_require__(31021))))));
			register("vue-i18n", "9.14.5", () => (Promise.all([__webpack_require__.e(9550), __webpack_require__.e(6962)]).then(() => (() => (__webpack_require__(49550))))));
			register("vue-router", "4.6.4", () => (Promise.all([__webpack_require__.e(4965), __webpack_require__.e(6962)]).then(() => (() => (__webpack_require__(74965))))));
			register("vue3-tags-input", "1.0.12", () => (Promise.all([__webpack_require__.e(6962), __webpack_require__.e(8181)]).then(() => (() => (__webpack_require__(78181))))));
			register("vue", "3.5.31", () => (__webpack_require__.e(5031).then(() => (() => (__webpack_require__(45031))))));
			register("vuex", "4.1.0", () => (Promise.all([__webpack_require__.e(2124), __webpack_require__.e(6962)]).then(() => (() => (__webpack_require__(82124))))));
			initExternal(63401);
			initExternal(51829);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};